module.exports = __webpack_public_path__ + "img/img26.a36204c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img26.jpg
// module id = 323
// module chunks = 0